export default __webpack_public_path__ + "static/media/Markers_Green Marker - Boat.e6197883.svg";